import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_DUE_LIST } from '../urls'
import { useMessage } from '../hooks/message'
import ManthlyDueForm from './ManthlyDueForm'

export default function ManthlyDueCreate({ onSuccess, onCancel }) {
    const brandCreate = usePostRequest({ url: MANTHLY_DUE_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success } = await brandCreate.request({ data })

        if (success) {
            showMessage('Успешно сохранен', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered"><b>Добавить</b></h1>

            <ManthlyDueForm
                loading={brandCreate.loading}
                onSubmit={onSubmit}
                onCancel={onCancel} />
        </div>
    )
}
